// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-actions-container-gOnCa {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  gap: 16px;
  padding: 20px;
  max-width: 400px;
  margin-left: auto;
}

.modal-actions-actionButton_base-MdSQh {
  width: 100%;
  flex: 1;
  height: 38px;
  border-radius: var(--radius-lg);
  min-width: 124px;
  max-width: 144px;
}

.modal-actions-multipleButtons-XSoqW .modal-actions-actionButton_base-MdSQh {
  max-width: none;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/modal-actions/modal-actions.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".container {\n  width: 100%;\n  display: flex;\n  flex-direction: row-reverse;\n  gap: 16px;\n  padding: 20px;\n  max-width: 400px;\n  margin-left: auto;\n}\n\n.actionButton_base {\n  width: 100%;\n  flex: 1;\n  height: 38px;\n  border-radius: var(--radius-lg);\n  min-width: 124px;\n  max-width: 144px;\n}\n\n.multipleButtons .actionButton_base {\n  max-width: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `modal-actions-container-gOnCa`,
	"actionButton_base": `modal-actions-actionButton_base-MdSQh`,
	"multipleButtons": `modal-actions-multipleButtons-XSoqW`
};
export default ___CSS_LOADER_EXPORT___;
